"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jul 23 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of Supplier
 * @author RV
 */


var SupplierConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierConverter, _DataObjectConverter_);

  function SupplierConverter() {
    _classCallCheck(this, SupplierConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierConverter).apply(this, arguments));
  }

  return SupplierConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierConverter = SupplierConverter;